import * as React from 'react';

import classnames from 'classnames';

import {reorder} from 'nutshell-core/list';
import type {FilterObject, CoreEntityType} from 'nutshell-core/types';

import {toggleSort} from '../../../entities/list/query/toggle-sort';

import {EntityTable} from '../../entity-list/entity-table/entity-table';
import {getSortObjectForEntityList} from '../../entity-list/get-sort-object-for-entity-list';

import styles from './sticky-scroll-entity-table-wrapper.module.css';

type Props = {
    filters: FilterObject[];
    selectedFields: string[];
    selectedPage: number;
    selectedSortField: string;
    schema: any;
    height: number;
    width: number;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onUpdateFields: (arg1: string[]) => any;
    onResizeColumn: () => any;
    onSortChange: (arg1: string) => any;
    entityType: CoreEntityType;
    isFirstLoad: boolean;
    isLoading: boolean;
    hasError: boolean;
    listItems: any[];
    toggleItem?: () => void;
};

export class StickyScrollEntityTableWrapper extends React.Component<Props> {
    render() {
        const {filters: selectedFilters, ...restProps} = this.props;
        const columnsWrapper = {
            selected: this.props.selectedFields,
            reorderFields: this.handleColumnReorder,
            resetToDefault: () => {},
            setFields: () => {},
        } as const;

        const filters = {
            selected: selectedFilters,
            removeAllFilters: () => {},
        } as const;

        const entityListClassname = {
            contacts: 'ui-entity-list--contacts',
            accounts: 'ui-entity-list--accounts',
            leads: 'ui-entity-list--leads',
        }[this.props.entityType];

        return (
            <div
                className={classnames(
                    `entity-list ui-entity-list ${entityListClassname}`,
                    styles['sticky-scroll-entity-table-wrapper']
                )}
            >
                <EntityTable
                    {...restProps}
                    entityType={this.props.entityType}
                    filters={filters}
                    columns={columnsWrapper}
                    onToggleSort={this.handleToggleSort}
                    sort={getSortObjectForEntityList(this.props.selectedSortField)}
                    schema={this.props.schema}
                    height={this.props.height}
                    width={this.props.width}
                    getRow={this.getRow}
                    rowCount={this.props.listItems.length}
                    unfilteredCount={4}
                    isAllSelected={false}
                    isFirstLoad={this.props.isFirstLoad}
                    isLoading={this.props.isLoading}
                    isFiltering={this.props.isLoading}
                    hasError={this.props.hasError}
                    checkRowSelected={() => false}
                    toggleItem={this.props.toggleItem}
                    onResizeColumn={this.props.onResizeColumn}
                    startScrolling={() => {}}
                    stopScrolling={() => {}}
                    includeColumnPicker={false}
                />
            </div>
        );
    }

    handleToggleSort = (fieldName?: string) => {
        const newSort = toggleSort(this.props.selectedSortField, fieldName);
        this.props.onSortChange(newSort);
    };

    handleColumnReorder = (field: string, newField: string) => {
        const newColumns = reorder(this.props.selectedFields, field, newField);
        this.props.onUpdateFields(newColumns);
    };

    getRow = (rowIndex: number) => {
        return this.props.listItems[rowIndex];
    };
}
